export const BREAKPOINT_MAX_WIDTH = {
  MOBILE_PORTRAIT: 568,
  MOBILE_LANDSCAPE: 750,
  TABLET_PORTRAIT: 1024,
  TABLET_LANDSCAPE: 1100,
  DESKTOP_SMALL: 1280,
};

export const NEAR_ME = 'NEAR_ME';

export const NEAR_ME_ITEM = {
  id: NEAR_ME,
};

export const HISTORY_ITEMS_TO_DISPLAY = 3;
export const HISTORY_MAX_TOTAL_ITEMS = 10;

export const GEOLOC = {
  MAXAGE: 60000,
  TIMEOUT: 5 * 1000,
  TIMEOUT_CODE: 3,
  MAX_TRIES: 5,
  MINUTE_HISTORY: 30,
  USER_DENIED: 1,
};

export const HCL_WEBSITE_HOST = process.env.HCL_WEBSITE_HOST;

export const SCREEN_NAME = {
  SEARCH_NEAR_ME: 'searchNearMe',
  SEARCH_BY_LOCATION: 'searchByLocation',
} as const;

export enum SEARCH_TARGET {
  HCO = 'HCO',
  HCP = 'HCP',
}
